import React from 'react';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import Tooltip from '../tooltip/main';
const T = Translator.create();
let _common: Common;



function ProgressCircle(props: any) {
    _common = new Common();
    const percent = props.percent ? props.percent.toFixed(0) : 0;
    let content = null;
    const color = props.color ? props.color : '#28a745';

    if (props.imageSrc) {
        content = (
            <span className="circle" data-percent={percent} style={{ width: '40px', height: '40px', }}>
                <i className="material-icons">
                    {props.imageSrc}
                </i>
            </span>
        );
    } else {
        content = (
            <span className="circle" data-percent={percent}>
                <small>%</small> {percent}
            </span>
        );
        if (percent === 100) {
            content = (<span className="circle">
                <img src={_common.GetDefaultIcons('done')} alt="" />
            </span>);
        }
    }

    if (percent <= 50) {
        const degValue = 180 * (percent / 50) + 90;
        return (
            <Tooltip data={props.disableTooltip 
                ?
                (null)
                :
                props.activityCard ?
                        <ul className="tooltip-list w-100">
                            <li>{T.t('r_complete_req')}<span>{T.t('r_activity_completion_criteria_'+ (props.activityCard!.completionType ? props.activityCard!.completionType : '1'))}</span></li>
                            <li>{T.t('r_completed_count')}<span>{props.activityCard!.completedUser ? props.activityCard!.completedUser : '0'}/{props.activityCard!.totalEnrollUser ? props.activityCard!.totalEnrollUser : '0'}</span></li>
                            {props.activityCard.completionCriteria>0 && <li>{T.t('r_progress_percentage')}:<span> %{props.activityCard.completionCriteria} </span></li>}
                        </ul>
            :  <ul className="tooltip-list w-100" style={{marginBottom: 7}}>
            <li>{T.t('r_complete_req')}<span  style={{color: "white"}}>{T.t('r_activity_completion_criteria_1')}</span></li>
            <li>{T.t('r_completed_count')}<span  style={{color: "white"}}> 0</span></li>
        </ul>} position='top' >
                    
                <span className="active-border" style={{ width: props.imageSrc ? '44px' : '32px', height: props.imageSrc ? '44px' : '32px', backgroundColor: 'rgb(200,200,200)', backgroundImage: 'linear-gradient(to right, rgb(200, 200, 200) 50%, transparent 50%, transparent), linear-gradient(' + degValue + 'deg, ' + color + ' 50%, rgb(200,200,200) 50%, rgb(200,200,200))' }}>
                    {content}
                </span>
               
            </Tooltip>
        );
    } else {
        const degValue = 180 * ((percent - 50) / 50) - 90;
        return (
            <Tooltip data={null}>
            <span className="active-border" style={{ width: props.imageSrc ? '44px' : '32px', height: props.imageSrc ? '44px' : '32px', backgroundColor: 'rgb(200,200,200)', backgroundImage: 'linear-gradient(' + degValue + 'deg, ' + color + ' 50%, transparent 50%, transparent), linear-gradient(to left, ' + color + ' 50%, rgb(200,200,200) 50%)' }}>
                {content}
            </span>
            </Tooltip>
        );
    }
}

export default ProgressCircle;
